import { View, Text, Platform } from 'react-native';
import { useSelector } from 'react-redux';
import { useWindowDimensions } from '../hooks/useWindowDimensions';
import styled from 'styled-components/native';
import {
  WorkoutContainerText,
  WorkoutCommonButton,
} from '../styles/common-styles.js';

function ContinueWorkout(props) {
  const { width } = useWindowDimensions();
  const { current_workout_activity, current_workout, workout_loading_msg } = useSelector((state) => state.cbcWorkout);

  const activityObj = [
    {
        activity_list: current_workout_activity.activity_choices,
        category_name: 'Free choice',
        category_text: 'Please select an activity from below.',
    },
  ];

  // Use optional chaining to avoid "undefined" errors
  const userInteractionType = props?.userInteractionType;

  ////console.log('userInteractionType', userInteractionType);
  const navigation = props.navigation;

  if (current_workout_activity?.activity_choices) {
    navigation.navigate('activitylist', {
      activityObj,
      current_workout,
      navigation,
      isWorkout:true
    });

    return;
  }

  try {
    // Use optional chaining to avoid "undefined" errors
    if (props?.route?.params?.userInteractionType === 1) {
      navigation.navigate('gameview', { current_workout_activity, current_workout });
      return;
    }

    if (props?.route?.params?.userInteractionType === 0) {
      navigation.navigate('dashboard');
      return;
    }

    ////console.log('default case, navigating to next game');
    navigation.navigate('gameview', { current_workout_activity, current_workout });
    return;

    ////console.log('userInteractionType', typeof userInteractionType);
    ////console.log('props.route.params.userInteractionType', props?.route?.params?.userInteractionType);
    ////console.log('props', props);
  } catch (e) {
    ////console.log('Error:', e);
  }

  return (
    <ContinueWorkoutParent screenWidth={width}>
      {/* Added a check for undefined explicitly */}
      {(typeof props?.route?.params?.userInteractionType !== 'undefined') && (
        <>
          <WorkoutContainerText>
            Would you like to continue your Workout?
          </WorkoutContainerText>
          {workout_loading_msg === 'idle' && (
            <ContinueWorkoutButtonContainer>
              <WorkoutCommonButton onPress={() => {
                props.navigation.navigate('gameview', { current_workout_activity, current_workout });
              }}>
                <Text style={{ color: 'white', fontWeight: '500' }}>KEEP GOING</Text>
              </WorkoutCommonButton>
              <WorkoutCommonButton onPress={() => props.navigation.navigate('dashboard')}>
                <Text style={{ color: 'white', fontWeight: '500' }}>QUIT</Text>
              </WorkoutCommonButton>
            </ContinueWorkoutButtonContainer>
          )}
        </>
      )}
    </ContinueWorkoutParent>
  );
}

export const ContinueWorkoutParent = styled.View`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;

export const ContinueWorkoutButtonContainer = styled.View`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 150px;
`;

export default ContinueWorkout;
